import { IFilterCargaPasstModel } from "../interfaces/passt/IFilterCargaPasstModel";

export class FilterCargaPasstModel implements IFilterCargaPasstModel{
    sedes: number[];    
    anio: number;
    idEstado: number;
    page: number;
    pageSize: number;
    idCompania: number;

    constructor(){
        this.sedes = [];
        this.anio= new Date().getFullYear();
        this.idEstado = 0;
        this.page = 1;
        this.pageSize = 30;
        this.idCompania = 0;
    }
}